import cl from 'clsx'
import styles from './styles.module.css'

export default function Checkbox({type, onChange}) {
    return (
        <label className={styles.checkboxContainer}>
            <input type="checkbox" className={styles.checkbox} onChange={onChange} />
            <span className={cl(
                styles.checkmark,
                type === "grey" && styles.checkmark__grey
            )}></span>
        </label>
    );
}